import { Tooltip } from 'components/ui'
import classNames from 'helpers/class-names'
import { capitalize } from 'lodash'
import moment from 'moment'
import { FC, ReactNode, useMemo } from 'react'

interface Props {
  by?: string | ReactNode
  action?: string
  at?: string | Date
  className?: string
  atClassName?: string
  byClassName?: string
  actionClassName?: string
}

export const Attribution: FC<Props> = ({
  by,
  action = 'created',
  at,
  className = '',
  atClassName = '',
  byClassName = '',
  actionClassName = '',
}) => {
  const formattedTime = useMemo(() => {
    if (!at) {
      return null
    }

    const date = moment(at)
    const now = moment()

    // Less than a minute ago
    if (now.diff(date, 'minute') < 1) {
      return 'Just now'
    }

    // Less than an hour ago
    if (now.diff(date, 'hour') < 1) {
      return `${now.diff(date, 'minute')}m ago`
    }

    // Less than a day ago
    if (now.diff(date, 'day') < 1) {
      return `${now.diff(date, 'hour')}h ago`
    }

    // Within the previous day
    if (now.diff(date, 'day') < 2) {
      return `Yesterday at ${date.format('h:mm A')}`
    }

    // This calendar year
    if (now.diff(date, 'year') < 1) {
      return `${date.format('MMM D')} at ${date.format('h:mm A')}`
    }

    return date.format('MMM D, YYYY')
  }, [at])

  return (
    <div
      className={classNames(
        'text-xs font-semibold tracking-normal text-gray-300',
        className,
      )}>
      <span className={actionClassName}>{capitalize(action)}</span>
      {Boolean(at) && (
        <>
          {' '}
          <Tooltip tip={moment(at).format('MMM D, YYYY [at] h:mm A')}>
            <span className={classNames('inline-block', atClassName)}>
              {formattedTime}
            </span>
          </Tooltip>
        </>
      )}
      {Boolean(by) && (
        <>
          {' by '}
          <span className={classNames(byClassName)}>{by}</span>
        </>
      )}
    </div>
  )
}

export default Attribution
